import { ConvexError } from 'convex/values'

export function isConnectionError(err: unknown) {
  if (err instanceof ConvexError) return false
  if (typeof navigator !== 'undefined' && !navigator.onLine) return true
  const msg = err instanceof Error ? err.message : String(err)
  return /connection lost|network|failed to fetch|timed? ?out|websocket/i.test(msg)
}

function backOnline(maxMs: number) {
  return new Promise<void>((resolve) => {
    const done = () => {
      clearTimeout(timer)
      window.removeEventListener('online', done)
      resolve()
    }
    const timer = setTimeout(done, maxMs)
    if (navigator.onLine) setTimeout(done, 0)
    else window.addEventListener('online', done)
  })
}

// Patchy signal (a walk, a train) drops actions mid-flight: wait for the
// connection and try again a few times before giving up.
export async function withReconnect<T>(
  run: () => Promise<T>,
  onRetry?: () => void,
  attempts = 3,
): Promise<T> {
  for (let attempt = 1; ; attempt++) {
    try {
      return await run()
    } catch (err) {
      if (attempt >= attempts || !isConnectionError(err)) throw err
      onRetry?.()
      await backOnline(30_000)
      await new Promise((r) => setTimeout(r, 1500 * attempt))
    }
  }
}
